import {Component, HostBinding, HostListener, Input} from '@angular/core';
import {BlockElementLabel} from 'app/entities/blockElements/blockElementContainer';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-label-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementLabelComponent extends BlockElementAbstractComponent<BlockElementLabel> {

  @HostBinding('class')
  get classes() {
    const classes = super.classes;

    if (this.blockElement.action) {
      classes.push('ion-activatable');
      classes.push('block-ripple-parent');
    }

    return classes;
  }

  @HostListener('click', ['$event'])
  onClick(e) {
    if (this.blockElement.action) {
      this.actionClick();
    }
  }
}
